import { FieldTypeEnum } from 'packages/sdks-next/growp'
import React from 'react'
import styled from 'styled-components'

/**
 * 问卷 - 题目后数量描述
 *
 * @param param - 参数
 * @param param.type - 题目类型
 * @param param.maxCount - 最大数量
 * @param param.minCount - 最小数量
 * @param param.fontSize - 字体大小
 * @returns React.RecatNode
 */
export const NumDescribe: React.FC<{
  type: FieldTypeEnum
  maxCount?: number
  minCount?: number
  fontSize: number
}> = ({ type, maxCount, minCount, fontSize }) => {
  return (
    <>
      {(minCount || maxCount) &&
      [FieldTypeEnum.Single, FieldTypeEnum.Multi].includes(type) ? (
        <ExtraInfo $fontSize={fontSize}>
          【{minCount ? `最少选${minCount}项` : null}
          {minCount && maxCount ? '，' : ''}
          {maxCount ? `最多选${maxCount}项` : null}】
        </ExtraInfo>
      ) : null}
      {(minCount || maxCount) && FieldTypeEnum.Attachment === type ? (
        <ExtraInfo>
          【{minCount ? `最少上传${minCount}项` : null}
          {minCount && maxCount ? '，' : ''}
          {maxCount ? `最多上传${maxCount}项` : null}】
        </ExtraInfo>
      ) : null}
    </>
  )
}

const ExtraInfo = styled.span<{ $fontSize?: number }>`
  font-size: ${(props) => `${props.$fontSize}px`};
  color: ${(props) => props.theme.text._3};
`
